import { useEffect } from 'react';
const useEventHandler = (event, handler) => {
    useEffect(() => {
        document.addEventListener(event, handler);
        return () => document.removeEventListener(event, handler);
    });
};
export default useEventHandler;
